var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticStyle:{"opacity":"0.85"},attrs:{"variant":_vm.type,"show":_vm.durations,"dismissible":_vm.close}},[_c('span',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }